// TODO Need to refactor backend error response object to avoid such comparing
export const backendErrors = {
  tenancy: "Selected branch doesn't have access to this tenancy.",
  deposit: "Selected branch doesn't have access to this deposit.",
  permissionDeniedToBranch: "PermissionDeniedToBranch",
  permissionDeniedError: "PermissionDeniedError",
};
